/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Excerpt1Inputs */

const vi_cmspost_excerpt1 = /** @type {(inputs: Cmspost_Excerpt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả ngắn`)
};

/**

* @param {Cmspost_Excerpt1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_excerpt1 = /** @type {((inputs?: Cmspost_Excerpt1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Excerpt1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_excerpt1(inputs)
});
export { cmspost_excerpt1 as "cmsPost_excerpt" }